export { FeaturesComponent, FeatureDisplayItem } from './features.component'; 